//import usMsaAll from '../components/Map/cb_2018_us_cbsa_20m_wkid102004.json1'

export default function cbsasMap(cbsaJson) {
  let idNameMap = new Map()
  cbsaJson['features'].forEach((value) => {
    idNameMap[value.properties['geoid']] = value.properties['name']
  })
  return idNameMap
}
